import Vue from "vue";
import VueLazyload from "vue-lazyload";
import AOS from "aos"
import "aos/dist/aos.css"
import App from "./App.vue";
import router from "@/router";
import store from "./store/";
import config from "./config";
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";

import VueSidebarMenu from 'vue-sidebar-menu'
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'

// import "./registerServiceWorker";

import "core-js/es6";
import "regenerator-runtime/runtime";

// importing the helper
import interceptorsSetup from './interceptors'

// and running it somewhere here
interceptorsSetup()

// Vue.config.devtools = true;

import "@/assets/css/azzahra-style.css";
import "@/assets/css/global.css";

// import "@/assets/style/main.scss";
// import "@/assets/css/style.css";
// import '@/assets/css/font.css'
// import '@/assets/addons/bootstrap-5.2.x/bootstrap-alt.css'
// import '@/assets/css/global.css?ts=<?php print time(); ?>'
// import '@/assets/css/animate.min.css'

// import "bootstrap-vue/dist/bootstrap-vue.css";

// import "@fortawesome/fontawesome-free/css/all.css";
// import "@fortawesome/fontawesome-free/js/all.js";

import { library } from "@fortawesome/fontawesome-svg-core";
import { faUserSecret } from "@fortawesome/free-solid-svg-icons";
import { faFontAwesome, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { BootstrapVue, BVToastPlugin, IconsPlugin } from "bootstrap-vue";
import OtpInput from "@bachdgvn/vue-otp-input";

// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.use(BVToastPlugin);

library.add(faFontAwesome, faUserSecret, faWhatsapp);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("v-otp-input", OtpInput);

import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize,
} from "vee-validate";
import id from "vee-validate/dist/locale/id.json";
import * as rules from "vee-validate/dist/rules";

// Install VeeValidate rules and localization
Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule]);
});

localize("id", id);

// Install VeeValidate components globally
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

// import VuePhoneNumberInput from "vue-phone-number-input";
// import "vue-phone-number-input/dist/vue-phone-number-input.css";
import './filters/money';


// Vue.component("vue-phone-number-input", VuePhoneNumberInput);

import VueCookies from "vue-cookies";
Vue.use(VueCookies);

import limitCategory from "@/mixins/limitCategory";
Vue.mixin(limitCategory);

Vue.use(VueLazyload);

Vue.use(VueSweetalert2);

Vue.use(VueSidebarMenu);

import { Plugin } from 'vue-fragment';
Vue.use(Plugin);


Vue.config.productionTip = false;
Vue.prototype.$cfg = config;

// import 'animate.css';

// register the plugin on vue
import Toasted from 'vue-toasted';
Vue.use(Toasted)

import IdleVue from "idle-vue";
import Vuex from "vuex";
Vue.use(Vuex);
// const store = new Vuex.Store({});

const eventsHub = new Vue();
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 60000, // 60 seconds,
  startAtIdle: false
});

import VueQuillEditor from 'vue-quill-editor'

import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
// vue 2 rich text editor
Vue.use(VueQuillEditor)

import vSelect from "vue-select";
Vue.component("v-select", vSelect);
import "vue-select/dist/vue-select.css";


import VueApexCharts from "vue-apexcharts"

Vue.component("apexchart", VueApexCharts)

// 🔥 Hapus service worker lama agar tidak error di staging/production
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (let registration of registrations) {
      registration.unregister()
      console.log('Service worker dihapus:', registration)
    }
  }).catch((err) => {
    console.error('Gagal unregister service worker:', err)
  })
}

// window.OneSignal = window.OneSignal || [];
// OneSignal.push(function () {
//   OneSignal.init({
//     appId: "4bcb5495-508c-4745-bab3-029030e9ea57", // ganti dengan App ID kamu
//     safari_web_id: "optional", // kalau butuh Safari push
//     notifyButton: {
//       enable: true, // munculin tombol subscribe
//     },
//   });
// });

new Vue({
  created() {
    AOS.init({
      easing: "ease-out-cubic",
      once: true,
      offset: 50,
    });
  },
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
